import { PaymentTerm } from '@cemex-core/cmx-api';
import { AdtPaymentTermActions, AdtPaymentTermActionTypes } from '../../actions/paymet-terms.action';

/**
 * Payment terms state
 */
export interface PaymentTermsState {
  loading: boolean;
  paymentTermSelected: PaymentTerm;
  paymentTermsByProduct?: { [productCode: string]: PaymentTerm[] };
  jobsitePaymentTerm?: PaymentTerm;
}

/**
 * Initial state of payment terms
 */
export const initialState: PaymentTermsState = {
  loading: false,
  paymentTermSelected: undefined,
  paymentTermsByProduct: undefined,
  jobsitePaymentTerm: undefined,
};

/**
 * Payment terms reducer
 * @param {PaymentTermsState} state Payment terms state
 * @param {AdtPaymentTermActions} action Payment terms actions
 * @returns {PaymentTermsState}
 */
export function adtPaymentTermsReducer(state = initialState, action: AdtPaymentTermActions): PaymentTermsState {
  switch (action.type) {
    case AdtPaymentTermActionTypes.LOAD_PAYMENT_TERM_SELECTED: {
      return {
        ...state,
        paymentTermSelected: action.payload,
      } as PaymentTermsState;
    }
    case AdtPaymentTermActionTypes.RESET_PAYMENT_TERM: {
      return {
        ...initialState,
      };
    }
    case AdtPaymentTermActionTypes.LOAD_JOBSITE_PAYMENT_TERM: {
      return {
        ...state,
        jobsitePaymentTerm: action.payload,
        loading: false,
      } as PaymentTermsState;
    }
    default: {
      return state;
    }
  }
}
